module.exports = __webpack_public_path__ + "static/img/product_anchorOut.80a4c2d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/product/product_anchorOut.png
// module id = GkVO
// module chunks = 0